import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function Analytics() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetch(`${API}/analytics/overview`)
      .then(r => r.json())
      .then(d => {
        if (d.success) setData(d.data)
        setLoading(false)
      })
      .catch(() => {
        setData({
          totalOrders: 156,
          totalRevenue: 45800,
          totalEnrollments: 89,
          totalChildren: 234,
          todayOrders: 5,
          todayRevenue: 1596,
          ordersByProduct: [
            { name: 'AI创作营·基础', count: 23 },
            { name: 'AI动画10次套', count: 18 },
            { name: '职业探索一日营', count: 15 },
            { name: '识字课程', count: 12 },
            { name: '其他', count: 88 }
          ],
          ordersByDay: [
            { date: '04-11', count: 5 },
            { date: '04-12', count: 8 },
            { date: '04-13', count: 6 },
            { date: '04-14', count: 12 },
            { date: '04-15', count: 9 },
            { date: '04-16', count: 15 },
            { date: '04-17', count: 5 }
          ]
        })
        setLoading(false)
      })
  }, [])

  if (loading) return <div style={{ padding: 40 }}>加载中...</div>

  const maxCount = data?.ordersByDay ? Math.max(...data.ordersByDay.map(d => d.count)) : 10

  return (
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>数据分析</h2>

      {/* Overview Stats */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
        <div style={cardStyle}>
          <div style={{ color: '#999', fontSize: 12 }}>总订?</div>
          <div style={{ fontSize: 28, color: '#1890ff' }}>{data?.totalOrders || 0}</div>
        </div>
        <div style={cardStyle}>
          <div style={{ color: '#999', fontSize: 12 }}>总收?</div>
          <div style={{ fontSize: 28, color: '#52c41a' }}>¥{(data?.totalRevenue || 0).toLocaleString()}</div>
        </div>
        <div style={cardStyle}>
          <div style={{ color: '#999', fontSize: 12 }}>报名人数</div>
          <div style={{ fontSize: 28, color: '#722ed1' }}>{data?.totalEnrollments || 0}</div>
        </div>
        <div style={cardStyle}>
          <div style={{ color: '#999', fontSize: 12 }}>学员?</div>
          <div style={{ fontSize: 28, color: '#fa8c16' }}>{data?.totalChildren || 0}</div>
        </div>
      </div>

      {/* Charts Row */}
      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 16 }}>
        {/* Daily Orders Chart */}
        <div style={cardStyle}>
          <h3 style={{ fontSize: 14, marginBottom: 16 }}>每日订单</h3>
          <div style={{ display: 'flex', alignItems: 'flex-end', height: 150, gap: 8 }}>
            {(data?.ordersByDay || []).map((d, i) => (
              <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div style={{
                  width: '100%',
                  height: `${(d.count / maxCount) * 130}px`,
                  background: '#1890ff',
                  borderRadius: '4px 4px 0 0',
                  transition: 'height 0.3s'
                }} />
                <div style={{ fontSize: 10, color: '#999', marginTop: 4 }}>{d.date}</div>
                <div style={{ fontSize: 11, color: '#333' }}>{d.count}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Product Distribution */}
        <div style={cardStyle}>
          <h3 style={{ fontSize: 14, marginBottom: 16 }}>产品分布</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {(data?.ordersByProduct || []).map((p, i) => {
              const total = data?.ordersByProduct?.reduce((s, x) => s + x.count, 0) || 1
              const pct = Math.round((p.count / total) * 100)
              return (
                <div key={i}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 4 }}>
                    <span>{p.name}</span>
                    <span style={{ color: '#666' }}>{p.count} ({pct}%)</span>
                  </div>
                  <div style={{ height: 6, background: '#f0f0f0', borderRadius: 3, overflow: 'hidden' }}>
                    <div style={{ width: `${pct}%`, height: '100%', background: ['#52c41a', '#fa8c16'][i] || '#1890ff' }} />
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
const cardStyle = {
  background: '#fff',
  borderRadius: 8,
  padding: 20,
  boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
}
